import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { GroupAlertFormPage } from './components/group-alert-form-page';
import { GroupAlerts } from './components/group-alerts';
import { Groups } from './components/groups';
import { GroupsFilterPage } from './components/groupsFilterPage';
import { GroupsToolbar } from './components/groupsToolbar';
import { groupPaths } from './groupPaths';

export const groupsRoutes = [
  {
    path: groupPaths.root,
    element: <Groups />,
    handle: {
      header: {
        titleKey: 'groups.menu.title',
        icon: 'google-circles-extended',
      },
      requiredPermission: Permissions.grouppage.read,
      toolbar: <GroupsToolbar />,
    },
  },
  {
    path: `${groupPaths.root}/filters`,
    element: <GroupsFilterPage />,
    handle: {
      header: {
        titleKey: 'groups.menu.title',
        icon: 'google-circles-extended',
      },
      requiredPermission: Permissions.grouppage.read,
      panel: {
        key: 'groups.menu.filters',
      },
    },
  },
  {
    path: `${groupPaths.root}/:groupId/alerts`,
    element: <GroupAlerts />,
    handle: {
      header: {
        titleKey: 'groups.menu.title',
        icon: 'google-circles-extended',
      },
      requiredPermission: Permissions.grouppage.read,
      panel: {
        key: 'groups.menu.alerts',
      },
    },
  },
  {
    path: `${groupPaths.root}/:groupId/alerts/new`,
    element: <GroupAlertFormPage />,
    handle: {
      header: {
        titleKey: 'groups.menu.title',
        icon: 'google-circles-extended',
      },
      requiredPermission: Permissions.grouppage.read,
      panel: {
        key: 'groups.menu.alerts.new',
      },
    },
  },
  {
    path: `${groupPaths.root}/:groupId/alerts/:alertId`,
    element: <GroupAlertFormPage />,
    handle: {
      header: {
        titleKey: 'groups.menu.title',
        icon: 'google-circles-extended',
      },
      requiredPermission: Permissions.grouppage.read,
      panel: {
        key: 'groups.menu.alerts.edit',
      },
    },
  },
];
